
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';
import { AdsGETApiAuth, AdsPUTApi, NodePOSTApiAuth, NodePOSTApiResetEmail } from '../../../Constant/api';
import { slugs } from '../../../Constant/slugs';
import { logout } from '../../../redux/action';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export default function ChaptersDetailsView(props) {
  // const { ChapterData } = props;
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory();
  const getDeviceFingerprint = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId; // unique & stable
  };
  const LoginState = useSelector((state) => state.LoginState);
  const [classDetails, setClassDetails] = React.useState({})
  const [choose, setChoose] = React.useState(0)
  const [PreviewUrl, setPreviewUrl] = React.useState("")
  const [Youtube, setYoutube] = React.useState(false)
  const [PreviewPressed, setPreviewPressed] = React.useState(false)
  const [PreviewType, setPreviewType] = React.useState("")
  const [PdfURL, setPdfURL] = React.useState("")
  const [ExamFetch, setExamFetch] = React.useState(false);
  const [NotFoundData, setNotFound] = React.useState(false)
  const [courseData, setCourseData] = React.useState({});
  const [ChapterData, setChapterData] = React.useState({});
  const [reload, setReload] = React.useState(true)
  const [superChapter, setSuperChapter] = React.useState("")
  const [courses, setCourses] = React.useState([])
  const [courses2, setCourses2] = React.useState([])
  const [Groups, setGroups] = React.useState([])
  
  const [OTP, setOTP] = React.useState("");
  const [OTPError, setOTPError] = React.useState(false);
  const [OTPCodeStore, setOTPCodeStore] = React.useState("");

  useEffect(() => {
    function ctrlShiftKey(e, keyCode) {
      return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
    }

    document.onkeydown = (e) => {
      // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
      if (
        // event.keyCode === 123 ||
        ctrlShiftKey(e, 'I') ||
        ctrlShiftKey(e, 'J') ||
        ctrlShiftKey(e, 'C') ||
        (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0))
      )
        return false;
    };
  }, [])
  var slug = location.pathname.slice(15);
  const [Email, setEmail] = React.useState("");
  const [Name, setName] = React.useState("");
  const [userID, setUserID] = React.useState("");
  const [newDeviceDetected, setNewDeviceDetected] = React.useState(false)

  useEffect(() => {
    GetAllData()
    const handleContextmenu = e => {
      e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
      document.removeEventListener('contextmenu', handleContextmenu)
    }
  }, [])


  const GetAllData = () => {
    setReload(true)
    AdsGETApiAuth({
      status: "any",
      "filter[meta_query][1][key]": "user_id",
      "filter[meta_query][1][value][0]": LoginState.userID,
      "filter[meta_query][1][compare]": "=",
      _fields: "meta,id"
    }, "user_data")
      .then((response) => {
        if (response.data.length !== 0) {
          var deviceid = response.data[0].meta.device_id
          console.log(deviceid)
          setName(response.data[0].meta.user_name)
          setEmail(response.data[0].meta.user_email)
          setUserID(response.data[0].id)
          getDeviceFingerprint().then(fingerprint => {
            if (deviceid == "") {
              var date = new Date()
              var today = date.toLocaleDateString()
              AdsPUTApi({
                meta: {
                  device_id: `${fingerprint}`
                }
              }, slugs.db_slug_user_data, response.data[0].id)
                .then(res => {
                  fetchExam()
                })
            }
            else if (deviceid == fingerprint) {
              fetchExam()
            }
            else {
              setNewDeviceDetected(true)
            }
          })
        }
        else
          dispatch(logout())
      })
      .catch(e => {
        if (e.message.includes("Request failed with status code 500"))
          dispatch(logout())
      })
  }

  const fetchExam = () => {
    setExamFetch(false)
    setNotFound(false)
    setReload(true)
    NodePOSTApiAuth({
      userID: LoginState.userID,
      courseslug: slug
    }, "single-course-details")
      .then((response) => {
        if (response.data.error)
          setNotFound(true)
        else {
          console.log(response.data)
          // setCourseData(response.data.course[0])
          var chapter = response.data.chapters[0]
          setClassDetails(chapter)

          var groupsList = response.data.chapters[0].meta.groups == "" ? [] : Object.values(JSON.parse(response.data.chapters[0].meta.groups))
          // console.log(classDetails.meta.groups)
          setGroups(groupsList)
          var allCourse = Object.values(JSON.parse(response.data.chapters[0].meta.course_content)).sort((a, b) => (a.chapter_number - b.chapter_number))
          setCourses(allCourse)
          setCourses2(allCourse)
          setChoose(1)
        }
      })
      .catch(e => {
        if (e.message.includes("Request failed with status code 500"))
          dispatch(logout())
      })
      .finally(() => {
        setExamFetch(true)
        setReload(false)
      })
  }

  const maskEmail = (email) => {
    if (!email || !email.includes("@")) return "";

    const [username, domain] = email.split("@");

    if (username.length <= 4) {
      return `${username.charAt(0)}****@${domain}`;
    }

    return `${username.slice(0, 2)}********${username.slice(-2)}@${domain}`;
  };

  const downloadImage = async (imageurl, filename) => {
    // const proxyUrl = "https://cors-anywhere.herokuapp.com/";
    // const imageUrl = "https://api.oppaonnihakwon.com/wp-content/uploads/2025/01/BUTAB.jpeg";
    var nodejsurl = "https://real-exam.epsexam.com/base64"
    axios({ method: "GET", url: `${nodejsurl}?url=${imageurl}` })
      .then(res => {
        const link = document.createElement("a");
        link.href = `data:application/pdf;base64,${res.data.data}`;
        link.download = filename;
        // setBase64(`data:image/jpeg;base64,${res.data.data}`)
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
  };
  return (
    <div style={{ margin: "3px" }}>

      <>
        {/* {choose == 1 &&
        <div className="row">
          <div className="col-1"></div>
          <div className="col-10 form-view mt-3">
            <div className="row" style={{ margin: "10px" }}>
              <h2>{classDetails.title.rendered}</h2>
              <section style={{ margin: "10px",display:"inline" }}>
                 <div 
                    style={{display:"inline-block",
                      padding: "10px ", border: "0.5px solid #999", cursor: "pointer",
                      backgroundColor: superChapter == "item" ? "#eee" : "#fff"
                    }}
                    onClick={() => {
                      setSuperChapter("सबै")
                      setCourses(courses2)
                    }}
                  >
                    सबै
                  </div>
                {Groups.map((item, index) => (
                  <div key={index}
                    style={{display:"inline-block",
                      padding: "10px ", border: "0.5px solid #999", cursor: "pointer",
                      backgroundColor: superChapter == item ? "#eee" : "#fff"
                    }}
                    onClick={() => {
                      setSuperChapter(item)
                      setCourses(courses2.filter(a=>a.group==item))
                    }}
                  >
                    {item}
                  </div>
                ))}


              </section>
              <div className="row" style={{ marginLeft: "10px" }}>
              
                {
                  courses.map((item2, index2) => (
                    // {Object.values(JSON.parse(classDetails.meta.course_content)).map((item2, index2) => (
                    // {ChapterData.map((item, index) => (
                    <div key={index2} className="col-md-4 col-12">
                      <div className="shadow" style={{ cursor: "pointer", backgroundColor: "#fff", margin: "10px 10px 0 0 ", padding: "10px" }}>
                        
                        <h4>{item2.chapter_number}. {item2.title}</h4>
                        <div style={{ fontSize: "12px" }}>{item2.description}</div>
                        <div style={{ fontSize: "10px", textAlign: "right" }}>({item2.time})</div>
                        <div style={{ fontSize: "10px", textAlign: "right" }}>{item2.is_preview}</div>
                        {item2.youtube_id !== "" &&
                          <div style={{ padding: 0, display: "inline" }}
                            onClick={() => {
                              var youtubeid = window.btoa(item2.youtube_id)
                              history.push(`/start-video/${youtubeid}`)
                            }}
                          >
                            <span style={{ border: "1px solid black", borderRadius: 5, padding: "3px 10px", fontSize: "12px" }}> Video</span>
                          </div>
                        }
                        <div style={{ padding: 0, display: "inline" }}>

                          {Object.values(JSON.parse(item2.pdf_list)).map((item4, index4) => (
                            <div key={index4} style={{ display: "inline-block", margin: 3 }}>
                              <span style={{ border: "1px solid black", borderRadius: 5, padding: "3px 10px", fontSize: "12px" }}
                                onClick={() => {
                                  setPreviewType("PDF")
                                  setPdfURL(item4)
                                }}
                              >
                                View PDF
                                {Object.values(JSON.parse(item2.pdf_list)).length == 1 ? "" : index4 + 1}
                              </span>
                            </div>
                          ))}
                        </div>
                        <div style={{ padding: 0, display: "inline" }}>
                          {Object.values(JSON.parse(item2.pdf_list)).map((item4, index4) => (
                            <div key={index4} style={{ display: "inline-block", margin: 3 }}>
                              <span style={{ border: "1px solid black", marginTop: 5, borderRadius: 5, padding: "3px 10px", fontSize: "12px" }}
                                onClick={() => {
                                  downloadImage(item4, `${item4.split("/")[item4.split("/").length - 1].replace(".pdf", "")}.pdf`)
                                }}
                              >
                                Download PDF
                                {Object.values(JSON.parse(item2.pdf_list)).length == 1 ? "" : index4 + 1}
                              </span>
                            </div>
                          ))}
                        </div>
                        <div style={{ marginLeft: "40px", fontSize: "12px" }}>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      } */}
      </>
      {choose === 1 && (
        <main className="chapter-details-page">
          <section className="chapter-details-panel">
            <h1 className="chapter-details-title">
              {classDetails.title?.rendered}
            </h1>

            <div className="chapter-filter-list">
              <button
                type="button"
                className={`chapter-filter-btn ${superChapter === "सबै" || superChapter === ""
                  ? "active"
                  : ""
                  }`}
                onClick={() => {
                  setSuperChapter("सबै");
                  setCourses(courses2);
                }}
              >
                सबै
              </button>

              {Groups.map((item) => (
                <button
                  type="button"
                  key={item}
                  className={`chapter-filter-btn ${superChapter === item ? "active" : ""
                    }`}
                  onClick={() => {
                    setSuperChapter(item);
                    setCourses(
                      courses2.filter(
                        (course) => course.group === item
                      )
                    );
                  }}
                >
                  {item}
                </button>
              ))}
            </div>

            <div className="chapter-content-grid">
              {courses.map((item2, index2) => {
                const pdfList = item2.pdf_list
                  ? Object.values(JSON.parse(item2.pdf_list))
                  : [];

                return (
                  <article
                    key={`${item2.chapter_number}-${index2}`}
                    className="lesson-card"
                  >
                    <div className="lesson-card-header">
                      <span className="lesson-number">
                        {item2.chapter_number}
                      </span>

                      <h2 className="lesson-title">
                        {item2.title}
                      </h2>
                    </div>

                    {item2.description && (
                      <p className="lesson-description">
                        {item2.description}
                      </p>
                    )}

                    <div className="lesson-meta">
                      {item2.time && (
                        <span className="lesson-date">
                          {item2.time}
                        </span>
                      )}

                      {item2.is_preview && (
                        <span className="lesson-author">
                          {item2.is_preview}
                        </span>
                      )}
                    </div>

                    <div className="lesson-actions">
                      {item2.youtube_id !== "" && (
                        <button
                          type="button"
                          className="lesson-action-btn video-btn"
                          onClick={() => {
                            const youtubeId = window.btoa(
                              item2.youtube_id
                            );

                            history.push(
                              `/start-video/${youtubeId}`
                            );
                          }}
                        >
                          Video
                        </button>
                      )}

                      {pdfList.map((pdf, pdfIndex) => (
                        <button
                          type="button"
                          key={`view-${pdfIndex}`}
                          className="lesson-action-btn view-pdf-btn"
                          onClick={() => {
                            setPreviewType("PDF");
                            setPdfURL(pdf);
                          }}
                        >
                          View PDF
                          {pdfList.length > 1
                            ? ` ${pdfIndex + 1}`
                            : ""}
                        </button>
                      ))}

                      {pdfList.map((pdf, pdfIndex) => (
                        <button
                          type="button"
                          key={`download-${pdfIndex}`}
                          className="lesson-action-btn download-pdf-btn"
                          onClick={() => {
                            const filename =
                              pdf
                                .split("/")
                                .at(-1)
                                ?.replace(".pdf", "") ||
                              `document-${pdfIndex + 1}`;

                            downloadImage(
                              pdf,
                              `${filename}.pdf`
                            );
                          }}
                        >
                          Download PDF
                          {pdfList.length > 1
                            ? ` ${pdfIndex + 1}`
                            : ""}
                        </button>
                      ))}
                    </div>
                  </article>
                );
              })}
            </div>

            {courses.length === 0 && (
              <div className="chapter-empty-state">
                No classes are available in this group.
              </div>
            )}
          </section>
        </main>
      )}
      {PreviewType == "PDF" &&
        <div class="modal-2" style={{
          userSelect: "none", marginTop: 0, top: 0
        }}>
          <div style={{ width: "100vw" }}
            onClick={() => { setPreviewType("") }}
          >
            <div
              data-dismiss="modal" aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </div>
          </div>
          <div>
            <div>
              <div className='d-sm-block d-none '>
                <iframe style={{ width: "100%", height: "95vh", position: "absolute", zIndex: 1 }}
                  src={`${PdfURL}`} />
              </div>
              <div className='d-block d-sm-none '>
                <iframe style={{ width: "100%", height: "95vh", position: "absolute", zIndex: 1 }}
                  src={`https://drive.google.com/viewerng/viewer?embedded=true&url=${PdfURL}`}
                />

              </div>
              <div >
              </div>
              <div style={{ padding: "37vh 50vw", backgroundColor: "#eee" }}>
                <div className="dot-pulse-2"></div>
              </div>
            </div>
          </div>
        </div>
      }

      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }

      {newDeviceDetected &&
        <div className="modal"
          onClick={() => {
          }}
        >
          <div>
            <div className="row " style={{ minHeight: "10vh", marginTop: "10vh" }}>
              <div className="col-sm-3 col-1"></div>
              <div className="col-sm-6 col-10 pb-5  bg-white  shadow">
                {choose == 0 &&
                  <>
                    <div className="device-popup-overlay">
                      <div className="device-popup">
                        <div className="warning-icon">!</div>

                        <h2 className="device-popup-title">Warning</h2>

                        <p className="device-popup-message">
                          तपाईंको Account अर्को Device मा Login भएको छ।
                          <br />
                          एक समयमा एउटा Device मा मात्र Login गर्न सकिन्छ।
                          <br />
                          कृपया Logout गर्नुहोस् वा यो Device प्रयोग गर्न{" "}
                          <strong>Reset Device</strong> गर्नुहोस्।
                          <br />
                          Reset Device गर्दा OTP तपाईंको registered Email
                          <br />

                          <span className="masked-email">
                            {maskEmail(Email)}
                          </span>

                          <br />
                          मा पठाइनेछ।
                        </p>

                        <div className="device-popup-note">
                          OTP verify भएपछि पुरानो Device automatically Logout हुनेछ।
                        </div>

                        <div className="device-popup-actions">
                          <button className="device-popup-btn logout-btn"
                            onClick={() => {
                              dispatch(logout())
                            }}
                          >
                            Logout
                          </button>

                          <button className="device-popup-btn reset-btn"
                            onClick={() => {
                              function generateRandomNumber() {
                                var minm = 100000;
                                var maxm = 999999;
                                return Math.floor(Math.random() * (maxm - minm + 1)) + minm;
                              }
                              const OTPCode = generateRandomNumber()
                              setOTPCodeStore(OTPCode)
                              NodePOSTApiResetEmail({
                                email: `${Email}`,
                                subject: `Reset Device ${OTPCode} Loksewa Network`,
                                body: `
नमस्कार ${Name},
<br/>
<br/>
तपाईंको खातासँग जोडिएको Device Reset गर्न अनुरोध प्राप्त भएको छ।
<br/>
Device Reset प्रक्रिया पूरा गर्न तल दिइएको OTP कोड प्रयोग गर्नुहोस्:
<br/>
<br/>
OTP कोड: <strong>${OTPCode}</strong>
<br/>
<br/>
यदि तपाईंले Device गर्न अनुरोध गर्नुभएको होइन भने, यो कोड कसैसँग साझा नगर्नुहोस् र यो इमेललाई बेवास्ता गर्नुहोस्।
<br/>
<br/>

सुरक्षाका लागि फोन, इमेल वा अन्य माध्यमबाट तपाईंको OTP कोड माग्ने छैन।
<br/>
<br/>

धन्यवाद,
<br/>
Loksewa Network- NEA
<br/>
Bagbazar, Kathmandu
`
                              }, "send_email")
                                .then(res => {
                                })
                              setChoose(1)

                            }}
                          >
                            Send OTP to Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                }
                {choose == 1 &&
                  <>
                    {/* <div className="p-5">
                      <div>Please enter the 6 digits otp received in your registered email?</div>
                      <div>
                        <input className='input-common'
                          placeholder='OTP'
                          onChange={(event) => {
                            setOTP(event.target.value)
                          }}
                        />
                      </div>
                      <div style={{ display: 'flex', cursor: 'pointer' }} className="center">
                        <div className="sign-in-button-2 col-4">
                          Logout
                        </div>
                        <div className="sign-in-button-1 col-4 mx-1">
                          Reset Device
                        </div>
                      </div>
                    </div> */}
                    <div className="otp-overlay">
                      <div className="otp-modal">

                        <h2 className="otp-title">
                          Please enter the 6 digits OTP received in your
                          registered email?
                        </h2>

                        <input
                          type="text"
                          className="otp-input"
                          placeholder="OTP"
                          maxLength={6}
                          value={OTP}
                          onChange={(event) => {
                            setOTP(event.target.value)
                            setOTPError(false)
                          }}

                        />
                        {/* {OTPCodeStore} */}
                        <p className="otp-error">
                          {OTPError &&
                            "Incorrect OTP. Please try again."
                          }
                        </p>

                        <div className="otp-buttons">
                          <button className="logout-btn"
                            onClick={() => {
                              dispatch(logout())
                            }}
                          >
                            Logout
                          </button>

                          <button className="reset-btn"
                            onClick={() => {
                              if (OTP != OTPCodeStore)
                                setOTPError(true)
                              else {
                                setReload(true)
                                setNewDeviceDetected(false)
                                AdsPUTApi({
                                  meta: {
                                    device_id: ``
                                  }
                                }, slugs.db_slug_user_data, userID)
                                  .then(res => {
                                    GetAllData()
                                  })
                              }
                            }}
                          >
                            Reset Device
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div >
  )
}

